import { ConnectedPosition } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PopoverPositions } from '@vendasta/galaxy/popover';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { FulfillmentOrder, FulfillmentOrderStatus } from '@vendasta/order-fulfillment';

@Component({
  selector: 'work-order-checklist',
  imports: [CommonModule, MatExpansionModule, GalaxyTooltipModule, TranslateModule, MatIconModule],
  templateUrl: './work-order-checklist.component.html',
  styleUrls: ['./work-order-checklist.component.scss'],
})
export class WorkOrderChecklistComponent {
  @Input() workOrders: FulfillmentOrder[] = [];

  public FULFILLMENT_ORDER_STATUS_DETAILS_NEEDED = FulfillmentOrderStatus.FULFILLMENT_ORDER_STATUS_DETAILS_NEEDED;

  constructor(
    private translateService: TranslateService,
    private router: Router,
  ) {}

  checklistTooltipText = this.translateService.instant('CHECKLIST.TOOLTIP_TEXT');
  positions: ConnectedPosition[] = [{ ...PopoverPositions.BottomLeft }];

  handleChecklistClick(appId: string): void {
    this.router.navigate([], { fragment: appId });
  }
}
